import { ProductType } from '@/data/types/Product';
import {
	ProductCardPLP,
	ProductCardPLPProps,
} from '@/components/content/CatalogEntryList/parts/ProductCardPLP';
import { useProductDetailsAddToCart } from '@/data/Content/ProductDetails';
import { useMemo } from 'react';
import { findProductAttribute } from 'integration/utils/findProductAttribute';

interface WishListItemProps extends ProductCardPLPProps {
	productId: string;
	onDeleteFromWishList: (...product: ProductType[]) => (skipAlert?: boolean) => Promise<void>;
}

export const AccountFavoriteItem: React.FC<WishListItemProps> = ({
	product,
	productId,
	onDeleteFromWishList,
	...rest
}) => {
	const { addToCart } = useProductDetailsAddToCart(product);

	const handleOnDeleteFromWishList = async (event: any) => {
		event.preventDefault();
		await onDeleteFromWishList({
			...product,
			id: productId,
		})();
	};

	const handleOnAddToCart = async (event: any) => {
		event.preventDefault();
		await addToCart(event);
	};

	const favoriteProductSelectSize = useMemo(
		() => findProductAttribute(product.attributes, 'Talla')?.value,
		[product]
	);

	return (
		<ProductCardPLP
			isFavorite
			product={product}
			localstorageRecord={{ favoriteProductSelectSize }}
			onToggleFavorite={handleOnDeleteFromWishList}
			onAddToCart={handleOnAddToCart}
			{...rest}
		/>
	);
};
